module.exports = __webpack_public_path__ + "img/Tour Performance TrueFit.e3095daf.jpg";